import { Input as AntdInput, InputProps } from "antd"

const Input = (props: InputProps & any): JSX.Element => {
  return <AntdInput {...props} style={{ color: props.disabled ? "#7A7A7A" : null }} />
}

export default Input
